import {Export} from "@tiptap-pro/extension-export";
import latexBlock from "./latexMath/latexBlock";
import DeeplinkNode from "../Deeplink/DeeplinkNode";
import {
    extFromMineType,
    getImagePathWithTheme,
    getImagePathWithThemeSvg,
    imgPathPerfix,
    isCardBlockDeeplink,
    sleep
} from "../../utils";
import {PopupCardPlus} from "../Plus/PopupCardPlus";
import {Indent} from "./indent";
import Link from "./extension-link/src";
import Image from "./imgResize";
import SearchNReplace from "./Search/plugin";
import {fileToBase64, ImagePaste} from "./ImagePaste";
import TaskItem from "./task-item";
import CodeBlockComponent from "./CodeBlock3";
import RenderCustomTable from "./Table/RenderCustomTable";
import CustomTableCell from "./TableCell/tableCell";
import StarterKit from "@tiptap/starter-kit";
import ListItem from '@tiptap/extension-list-item'
import OrderedList from '@tiptap/extension-ordered-list'
import BulletList from '@tiptap/extension-bullet-list'
import { Plugin,PluginKey, TextSelection } from 'prosemirror-state';
import ListKeymap from '@tiptap/extension-list-keymap'
import {Youtube} from "../EditorV2/extension-youtube";
import HardBreak from '@tiptap/extension-hard-break'
import Mathematics from '@tiptap-pro/extension-mathematics'
import {UniqueID} from "@tiptap-pro/extension-unique-id";
import Focus from '@tiptap/extension-focus'
import Gapcursor from '@tiptap/extension-gapcursor'
import Heading from "@tiptap/extension-heading";
import { Color } from "@tiptap/extension-color";
import Text from "@tiptap/extension-text";
import TextStyle from "@tiptap/extension-text-style";
import {
    Extension,
    markPasteRule,
    mergeAttributes,
    InputRule,
    markInputRule,
} from "@tiptap/core";
import Paragraph from "@tiptap/extension-paragraph";
import Highlight from "@tiptap/extension-highlight";
import TextAlign from "@tiptap/extension-text-align";
import Underline from "@tiptap/extension-underline";
import ImageT from '@tiptap/extension-image'
import Background from 'tiptap-extension-background-color'
import TaskList from '@tiptap/extension-task-list'
import Placeholder from "@tiptap/extension-placeholder";
import HorizontalRule from '@tiptap/extension-horizontal-rule'
import Blockquote from '@tiptap/extension-blockquote'
import {FontFamily} from "@tiptap/extension-font-family";
import CodeBlockLowlight from '@tiptap/extension-code-block-lowlight';
import {TableRow} from "@tiptap/extension-table-row";
import {TableHeader} from "@tiptap/extension-table-header";
import {useEditor, EditorContent, BubbleMenu, ReactNodeViewRenderer} from "@tiptap/react";
import {lowlight} from "lowlight";
import FontSize from 'tiptap-extension-font-size'
import {Hyperlink} from "@/components/EditorV2/extension-hyperlink";
import { autolink } from './extension-link/src/helpers/autolink.js'
import clickHandler  from './extension-hyperlink/src/helpers/clickHandler'
import { pasteHandler } from './extension-link/src/helpers/pasteHandler.js'
import { Bold } from "@tiptap/extension-bold";
import { Italic } from "@tiptap/extension-italic";
import { Strike } from "@tiptap/extension-strike";
import {getListItemExtend} from "@/components/EditorV2/EditorExtensions/ListItemExtend";
import {getBubblletListExtend} from "@/components/EditorV2/EditorExtensions/BulletListExtend";
import {handleBackspace, handleShiftTab, handleTab} from "@/components/EditorV2/TiptapCommonHandle";
import latexInline from "@/components/EditorV2/latexInline/latexInline";
import {getHeadingExtend} from "@/components/EditorV2/EditorExtensions/HeadingExtend";
import {MAX_IMAGE_FILE_SIZE} from "@/Const";
import {ipcInvoke} from "@/common/ipc";
import CodeInlie from '@tiptap/extension-code'
import {isWeb} from "@/electron_interactive";
import { Decoration, DecorationSet } from "@tiptap/pm/view";

const showLink = (editor)=>{
    const text = editor.state.selection.content()?.content?.content?.[0]?.textContent;
    global.g_newCardTitle = text;

    let link = editor.getAttributes('link').href

    // window.showDialogCardLink({link, text}, (r: any) => {
    //     if (r?.delete) {
    //         editor.commands.unsetLink()
    //         // editor.commands.unsetHyperlink()
    //     } else if (r) {
    //         editor.commands.setLink({href: r.link, target: '_blank'})
    //         // editor.commands.setHyperlink({href: r.link, target: '_blank'})
    //     }
    //
    //     updateEditCardHtml();
    //     props.app.pushHistory();
    // })
    //关闭editor的焦点，以防止粘贴图片到库中的问题。。。
    editor.commands.blur();

    window.showDialogLink(link, 'card', (item) => {
        if (!item) {
            editor.commands.unsetLink()
            // editor.commands.unsetHyperlink()
        } else {
            editor.commands.setLink({href: item, target: '_blank'})
        }
        // setTimeout(() => {
        //     window.hookATags();
        // }, 600)

        // updateEditCardHtml();
        // syncNoteData(null,true);
        // props.app.pushHistory();
    })
}

export const getTiptapExtension =(editor0,from)=>{
    let extensions = [
        StarterKit.configure({
            // history:false,
        }),
        // InlineCodeMark,
        CodeInlie,
        getListItemExtend(from),
        OrderedList.extend({
            addAttributes() {
                return {
                    ...this.parent?.(), // 保留原有的属性
                    blockHighlight: {
                        default: false,
                    },
                    noteText: {
                        default: ''
                    },
                    ifhidden: {
                        default: false,
                        renderHTML: attributes => {
                            if (attributes.ifhidden === undefined) {
                                return {};
                            }
                            return {
                                'ifhidden': attributes.ifhidden,
                            };
                        },
                    },
                };
            },
        }),
        getBubblletListExtend(),
        Youtube.extend({
            addAttributes() {
                return {
                    ...this.parent?.(), // 保留原有的属性
                    highlightImgUrl: {
                        default: '',
                    },
                    noteText: {
                        default: ''
                    },
                    ifhidden: {
                        default: false,
                        renderHTML: attributes => {
                            if (attributes.ifhidden === undefined) {
                                return {};
                            }
                            return {
                                'ifhidden': attributes.ifhidden,
                            };
                        },
                    },
                };
            },
        }),
        // ListKeymap,

        HardBreak.extend({
            addKeyboardShortcuts() {
                return {
                    "Mod-z":({editor})=>{
                        const history = editor.extensionStorage.history;
                        console.log(history)
                    },
                    "Mod-e":({editor})=>{
                        //  2. 行内代码快捷键：在卡片中选中文字，windows点击ctrl+E，mac中点击cmd+E，就能将选中的文字转换为行内代码，参考notion，详见视频3
                        editor.chain().focus().toggleCode().run();
                        return true;
                    },
                    "Mod-k":({editor})=>{
                        if (editor.state.selection.from != editor.state.selection.to){
                            showLink(editor);
                        }else{
                            //显示全局的搜索.
                            window.showDialogGlobalSearch();
                        }
                    },
                    "Mod-Shift-e":({editor})=>{
                        const selectedText = editor.state.doc.textBetween(
                            editor.state.selection.from,
                            editor.state.selection.to,
                            "\n"  // 节点分隔符
                        );
                        if (selectedText){
                            editor.commands.insertContent(`<latex-inline data-metaData="${selectedText}" data-firstCreate="true"></latex-inline>`)
                        }else{
                            editor.commands.insertContent(`<latex-inline data-firstCreate="true"></latex-inline>`)
                        }

                        return true;
                    },
                    "Mod-E":({editor})=>{
                        //  2. 行内代码快捷键：在卡片中选中文字，windows点击ctrl+E，mac中点击cmd+E，就能将选中的文字转换为行内代码，参考notion，详见视频3
                        editor.chain().focus().toggleCode().run();
                        return true;
                    },
                    "Mod-K":({editor})=>{
                        showLink(editor);
                    },
                    "Mod-Shift-E":({editor})=>{
                        const selectedText = editor.state.doc.textBetween(
                            editor.state.selection.from,
                            editor.state.selection.to,
                            "\n"  // 节点分隔符
                        );
                        if (selectedText){
                            editor.commands.insertContent(`<latex-inline data-metaData="${selectedText}" data-firstCreate="true"></latex-inline>`)
                        }else{
                            editor.commands.insertContent(`<latex-inline data-firstCreate="true"></latex-inline>`)
                        }

                        return true;
                    },
                    Enter: ({editor}) => {
                        // setTimeout(()=>{
                        //   window.hookATags();
                        // },100)

                        const divCustomDrag = document.querySelector(".drag-handle");
                        if(divCustomDrag){
                            divCustomDrag.style.display = "none";
                        }

                        const { from, to } = editor.state.selection;
                        const resolvedPos = editor.state.doc.resolve(from);
                        // 获取当前节点
                        const currentNode = resolvedPos.node();
                        const parentNode = resolvedPos.node(resolvedPos.depth - 1);
                        const grandNode = resolvedPos.node(resolvedPos.depth - 2);
                        const nodeStart = resolvedPos.start(resolvedPos.depth);
                        const nodeEnd = resolvedPos.end(resolvedPos.depth);

                        if (currentNode.type.name === 'paragraph' && nodeEnd === from && from === to && parentNode.type.name === 'listItem' && parentNode.attrs.listFold === true) {
                            // 插入新的listitem
                            const resolvedPos1 = editor.state.doc.resolve(from);
                            const parentResolvedPos = editor.state.doc.resolve(resolvedPos1.start(resolvedPos1.depth - 1));
                            const parentFrom = parentResolvedPos.start(parentResolvedPos.depth);
                            const parentTo = parentResolvedPos.end(parentResolvedPos.depth);
                            const listItemType = parentNode.type

                            const paragraph = editor.state.schema.nodes.paragraph.create()
                            const newListItem = listItemType.create(null, paragraph)
                            const tr = editor.state.tr.insert(parentTo, newListItem)
                            const resolvedPos = tr.doc.resolve(parentTo + 1)
                            tr.setSelection(TextSelection.near(resolvedPos))
                            editor.view.dispatch(tr.scrollIntoView())
                            // debugger
                            return true
                        }
                        if (resolvedPos.parentOffset === 0 && currentNode.type.name === 'paragraph') {
                            setTimeout(() => {
                                const { from, to } = editor.state.selection;
                                const resolvedPos = editor.state.doc.resolve(from);
                                // 获取下一个节点
                                const node = resolvedPos.node();
                                let tempID= node.attrs.id
                                node.attrs.id=currentNode.attrs.id
                                currentNode.attrs.id=tempID

                            }, 100);
                        }
                        return false;
                    },
                    /*
                    Backspace: () => {
                      // 取消高亮
                      editorRef.current.commands.unsetHighlight();
                      setTimeout(()=>{
                        window.hookATags();
                      },100)

                      const { state,view } = this.editor;
                      const { selection } = state;
                      const { from, to } = this.editor.state.selection;
                      const resolvedPos = this.editor.state.doc.resolve(from);
                      // 获取当前节点
                      const currentNode = resolvedPos.node();

                      // 获取当前节点的起始位置
                      const nodeStart = resolvedPos.start(resolvedPos.depth);
                      const parentNode = resolvedPos.node(resolvedPos.depth - 1);
                      const grandNode = resolvedPos.node(resolvedPos.depth - 2);
                      const grandGrandNode = resolvedPos.node(resolvedPos.depth - 3);

                      const grandResolvedPos = this.editor.state.doc.resolve(resolvedPos.start(resolvedPos.depth - 2));
                      const grandResolvedPosFrom = grandResolvedPos.start(grandResolvedPos.depth);
                      const isEmptyParagraph = currentNode.type.name === 'paragraph' && currentNode.content.size === 0;
                      if (from === to && from === 1) {
                        if (txtTitleRef.current && isEmptyParagraph) {
                          const tr = state.tr.deleteRange(0, currentNode.nodeSize);
                          view.dispatch(tr);
                          const length = txtTitleRef.current.value.length;
                          txtTitleRef.current.focus();
                          txtTitleRef.current.setSelectionRange(length, length);
                        }
                      }

                      //这里增加一个删除？？？？？？？？？？？？？？？？
                      const doc = editorRef.current.state.doc;
                      let preNode = null;
                      doc.descendants((node,pos)=>{
                        if (node.attrs.id == currentNode.attrs.id){
                          return false;
                        }
                        preNode = node;
                        return true;
                      })
                      if (preNode && (preNode.type?.name == 'deeplink' || preNode.type?.name == 'image')){
                        editorRef.current.commands.deleteRange({from:from-1,to:to});
                        if (preNode.type?.name == 'image'){
                          if (preNode.attrs.src?.startsWith('atom://')){
                            var reg = new RegExp(preNode.attrs.src,'gi');
                            const matchs = editorRef.current.getHTML().match(reg);
                            if (matchs && matchs.length <= 1){
                              removeCardImage(preNode.attrs.src.replace('atom://',''))
                            }
                          }
                        }
                        return;
                      }


                      if (currentNode.type.name === 'paragraph' && selection.$from.pos === nodeStart && currentNode.attrs?.indent > 0 && parentNode.type.name !== 'taskItem' && parentNode.type.name !== 'listItem') {
                        this.editor.commands.outdent()
                        return true
                      } else if (currentNode.type.name === 'paragraph' && (selection.$from.pos === nodeStart) && (parentNode.type.name === 'taskItem' || parentNode.type.name === 'listItem')) {
                        // 全选情况下
                        if (((selection.to - selection.from) === (grandNode.nodeSize - 6) || (selection.to - selection.from) === (parentNode.nodeSize - 4)) && selection.from !== selection.to) {
                          return false;
                        }
                        const resolvedPos1 = this.editor.state.doc.resolve(to);
                        const currentNode1 = resolvedPos1.node();
                        const parentNode1 = resolvedPos1.node(resolvedPos1.depth - 1);

                        const parentResolvedPos = this.editor.state.doc.resolve(resolvedPos1.start(resolvedPos1.depth - 1));
                        const from3 = parentResolvedPos.start(parentResolvedPos.depth);
                        const to3 = parentResolvedPos.end(parentResolvedPos.depth);

                        const parentResolvedPos2 = this.editor.state.doc.resolve(resolvedPos.start(resolvedPos.depth - 1));
                        const from4 = parentResolvedPos2.start(parentResolvedPos2.depth);
                        const to4 = parentResolvedPos2.end(parentResolvedPos2.depth);
                        // 完全选中多行情况下且为嵌套list
                        if (from4 + 1 === from && to3 - 1 === to && from !== to) {
                          // 如果是嵌套list的第一层
                          if (from === to && ['listItem', 'taskItem'].includes(grandGrandNode.type.name) && grandResolvedPosFrom + 2 === from) {
                            this.editor.commands.deleteRange({ from: grandResolvedPosFrom-2, to: from })
                            return true;
                          }
                          this.editor.commands.deleteRange({ from: from, to: to })
                          return true;
                        }


                        if (parentNode.type.name === 'taskItem') {
                          // console.log('---1---');
                          this.editor.chain().focus().toggleTaskList().run()
                          // if(selection.$from.pos - 1 === nodeStart && currentNode.textContent.includes("\u200B")){
                          //   this.editor.commands.deleteRange({ from: selection.from - 1, to: selection.to })
                          // }
                        } else if (parentNode.type.name === 'listItem' && grandNode.type.name === 'bulletList') {
                          // console.log('---2---');
                          this.editor.chain().focus().toggleBulletList().run()
                          // if(selection.$from.pos - 1 === nodeStart && currentNode.textContent.includes("\u200B")){
                          //   console.log('----asdasdasdasd',selection.from,selection.to);
                          //   this.editor.commands.deleteRange({ from: selection.from-1, to: selection.to })
                          // }
                        } else if (parentNode.type.name === 'listItem' && grandNode.type.name === 'orderedList') {
                          // console.log('---3---');
                          this.editor.chain().focus().toggleOrderedList().run()
                          // if(selection.$from.pos - 1 === nodeStart && currentNode.textContent.includes("\u200B")){
                          //   this.editor.commands.deleteRange({ from: selection.from - 1, to: selection.to })
                          // }
                          editorRef.current.view.state.doc.descendants((node, pos) => {
                            const from = pos;
                            const to = pos + node.nodeSize;
                          });
                        }
                        return true
                      }
                      else {
                        setTimeout(()=>{
                          try{
                            const { state, view } = this.editor;
                            const { dispatch } = view;
                            const { doc } = state;
                            // 合并两个numberList
                            const lastNodePos = from - 2;
                            let nextNodePos = from + 2;
                            if (nextNodePos > to){
                              nextNodePos = to;
                            }

                            const lastNodeResolved = doc.resolve(lastNodePos);
                            const nextNodeResolved = doc.resolve(nextNodePos);

                            const lastNode = lastNodeResolved.node();
                            const nextNode = nextNodeResolved.node();
                            if (lastNode.type.name === 'orderedList' && nextNode.type.name === 'orderedList') {
                              const tr = state.tr;

                              // Find the position where the nextNode starts
                              const nextNodeStart = nextNodeResolved.start();

                              nextNode.content.content.forEach((child: Node, offset: number) => {
                                tr.insert(from - 4, child);
                              });
                              tr.delete(nextNodeStart - 1, nextNodeStart + nextNode.nodeSize);

                              if (dispatch) {
                                dispatch(tr);
                                editorRef.current.commands.focus(editorRef.current.state.selection.from - 0)
                              }
                            }
                          }catch (e){
                            console.log(e)
                          }
                        },10)

                        return false;
                      }
                    }
                    */
                    // 不改底层的版本
                    Backspace: ({editor}) => {
                        const { from, to } = editor.state.selection;
                        if (editor.isEmpty || (from == to && from <= 1)){
                            //标题获取焦点
                            // if (!mHasTitleEmpty.current){
                            //     txtTitleRef.current?.focus();
                            //     // return true;//不要返回了，影响下面的.
                            // }
                        }
                        // 取消高亮
                        return handleBackspace(editor,null);
                    },
                    Tab: ({editor}) => {
                        return handleTab(editor);
                    },
                    'Shift-Tab': ({editor}) => {
                        return handleShiftTab(editor);
                    }
                }
            }
        }),
        // Mathematics.configure({
        //   // regex: /\&\&([^\&]*)\&\&/gi
        // }),
        latexInline,
        latexBlock,
        UniqueID.configure({
            types: ['tableRow', 'taskList', 'paragraph','deeplink', 'image', 'blockquote', 'bulletList', 'orderedList', 'horizontalRule', 'youtube', 'table', 'highlight', 'latexBlock'],
            filterTransaction: transaction => {
                return !transaction.getMeta('preventUpdate')
            }
        }),
        Focus.configure({
            className: 'has-focus',
            mode: 'deepest',
        }),
        Gapcursor,
        Text,
        TextStyle,
        Color,
        getHeadingExtend(),
        Paragraph.extend({
            addAttributes() {
                return {
                    ...this.parent?.(),
                    ifhidden: {
                        default: false,
                        renderHTML: attributes => {
                            if (attributes.ifhidden === undefined) {
                                return {};
                            }
                            return {
                                'ifhidden': attributes.ifhidden,
                            };
                        },
                    },
                };
            },
        }),
        Highlight.configure({ multicolor: true }).extend({
            addAttributes() {
                return {
                    ...this.parent?.(),
                    id: {
                        default: crypto.randomUUID()
                    },
                    noteText: {
                        default: '',
                    },
                };
            },
            addCommands() {
                return {
                    ...this.parent?.(),
                    setHighlightId: (id,from) =>async  ({ tr, state, dispatch }) => {
                        // 改变id后立即渲染到页面中
                        const resolvedPos = state.doc.resolve(from);
                        const currentNode = resolvedPos.node().content.content[0];
                        const currentMark = currentNode.marks[0];

                        // 创建新的 mark，只更新 id
                        const newMark = currentMark.type.create({
                            ...currentMark.attrs,
                            id: id
                        });

                        // 替换 mark
                        const transaction = tr.removeMark(from, from + currentNode.text.length, currentMark)
                            .addMark(from, from + currentNode.text.length, newMark);

                        if (dispatch) {
                            dispatch(transaction);
                        }
                        return true;
                    }
                };
            }
        }),
        TextAlign.configure({
            types: ["heading", "paragraph"],
        }).extend({
            addKeyboardShortcuts() {
                return{
                    "Mod-Shift-e":()=>{
                        return false;
                    },
                    "Mod-Shift-E":()=>{
                        return false;
                    },
                }
            }
        }),
        Underline,
        PopupCardPlus,
        Placeholder.configure({
            placeholder: '',
        }),
        FontSize,
        Indent,
        Link.configure({
            protocols: ['noteey', 'noteeditor'],
            autolink: false,
            linkOnPaste: false,
            openOnClick: true
        }).extend({
            addAttributes() {
                return {
                    ...this.parent?.(),
                    ifhidden: {
                        default: false,
                        renderHTML: attributes => {
                            if (attributes.ifhidden === undefined) {
                                return {};
                            }
                            return {
                                'ifhidden': attributes.ifhidden,
                            };
                        },
                    }
                }
            }
        }),
        ImageT.extend({
            addAttributes() {
                return {
                    ...this.parent?.(),
                    noteText: {
                        default: '',
                    },
                };
            }
        }),
        Background,
        Image.configure({
            allowBase64: true
        }),
        getHyperlinkExtension(),
        SearchNReplace.configure({
            searchResultClass: "search-result", // class to give to found items. default 'search-result'
            caseSensitive: false, // no need to explain
            disableRegex: false, // also no need to explain
        }),
        ImagePaste.configure({
            fileMatchRegex: /^image\/(gif|jpe?g|a?png|svg|webp|bmp)/i,
            disableImagePaste: false,
            render: () => {
                return {
                    onImagePaste: files => {
                        files.forEach(file => {
                            if (file.size > MAX_IMAGE_FILE_SIZE){
                                const id = crypto.randomUUID();
                                const szFileName = id +'.' + extFromMineType(file.type);
                                ipcInvoke('resize-image-file',{filePath:file.path,name:szFileName,type:file.type,toLocal:true})?.then((szFilePath)=>{
                                    editor.chain().focus().setImage({src: 'atom://' +szFileName}).run()
                                    editor.commands.blur()
                                })
                            }else{
                                fileToBase64(file).then(r => {
                                    const id = crypto.randomUUID();
                                    model.addImg(id, r)
                                    editor.chain().focus().setImage({src: 'atom://' + id + '.jpeg'}).run()
                                    editor.commands.blur()
                                })
                            }

                            // fileToBase64(file).then(r => {
                            //   const id = crypto.randomUUID();
                            //   model.addImg(id, r)
                            //   editorRef.current?.chain().focus().setImage({src: 'atom://' + id + '.jpeg'}).run()
                            //   editorRef.current?.commands.blur()
                            // })
                        });
                    },
                    onDisabledImagePaste: text => {
                        console.log('text: ', text);
                        // add text to editor if you want, or display an error/upselll message
                    },
                    // onImageDrop: files => {
                    //   files.forEach(file => {
                    //     fileToBase64(file).then(r => {
                    //       const id = crypto.randomUUID();
                    //       model.addImg(id, r)
                    //       window.GEditor.chain().focus().setImage({src: 'atom://' + id + '.jpeg'}).run()
                    //       window.GEditor.commands.blur()
                    //     })
                    //   });
                    // },
                };
            },
        }),
        TaskList.extend({
            addAttributes() {
                return {
                    ...this.parent?.(), // 保留原有的属性
                    blockHighlight: {
                        default: false,
                    },
                    noteText: {
                        default: ''
                    },
                    ifhidden: {
                        default: false,
                        renderHTML: attributes => {
                            if (attributes.ifhidden === undefined) {
                                return {};
                            }
                            return {
                                'ifhidden': attributes.ifhidden,
                            };
                        },
                    }
                };
            },
        }),
        TaskItem.configure({
            nested: true,
        }),
        HorizontalRule.extend({
            addAttributes() {
                return {
                    ...this.parent?.(), // 保留原有的属性
                    ifhidden: {
                        default: false,
                        renderHTML: attributes => {
                            if (attributes.ifhidden === undefined) {
                                return {};
                            }
                            return {
                                'ifhidden': attributes.ifhidden,
                            };
                        },
                    }
                };
            },
        }),
        Blockquote.extend({
            addAttributes() {
                return {
                    ...this.parent?.(), // 保留原有的属性
                    ifhidden: {
                        default: false,
                        renderHTML: attributes => {
                            if (attributes.ifhidden === undefined) {
                                return {};
                            }
                            return {
                                'ifhidden': attributes.ifhidden,
                            };
                        },
                    }
                };
            },
        }),
        FontFamily,
        CodeBlockLowlight.extend({
            addNodeView() {
                return ReactNodeViewRenderer(CodeBlockComponent);
            },
            addAttributes() {
                return {
                    id: {
                        default: () => {
                            return null
                        },  // 生成唯一的 ID，只有第一次创建时生成
                        parseHTML: element => {
                            const aa = element?.lastElementChild?.getAttribute('id') || crypto.randomUUID()
                            // return element?.lastElementChild?.getAttribute('id') || crypto.randomUUID(); // 如果没有 id，从 HTML 中获取
                            return aa; // 如果没有 id，从 HTML 中获取
                        },
                    },
                    ifhidden: {
                        default: false,
                        renderHTML: attributes => {
                            if (attributes.ifhidden === undefined) {
                                return {};
                            }
                            return {
                                'ifhidden': attributes.ifhidden,
                            };
                        },
                    },
                    language: {
                        default: 'Auto'
                    }
                };
            }
        }).configure({lowlight}),
        DeeplinkNode,
        RenderCustomTable.configure({
            resizable: true,
            lastColumnResizable:true,
            allowTableNodeSelection: true,
        }),
        TableHeader,
        CustomTableCell,
        TableRow,
        getBoldExtension(),
        getItalicExtension(),
        getStrikeExtension()
    ];
    if (!isWeb()){
        extensions.push(Export.configure(window.IPC.getConvertToken()))
    }
    return extensions;
}

export const getHyperlinkExtension = (callback:any)=>{
    return Hyperlink.configure({
        HTMLAttributes: {
            target: '_self',
        },
        autoHyperlink: false,
        openOnClick: true,
    }).extend({
        addPasteRules() {
            return [];
        },
        addProseMirrorPlugins() {
            const plugins: Plugin[] = []
            let editor=this.editor
            function customClickHandler(type, options) {
                const baseClickHandler = clickHandler({
                    type: type,
                    editor: editor,
                    validate: options.validate,
                    modal:options.modals.previewHyperlink,
                })

                return new Plugin({
                    key: new PluginKey('customClickHandler'),
                    props: {
                        handleClick(view, pos, event) {
                            // const attrs = getMarkAttributes(view.state, type)
                            //block链接
                            //点击block
                            //打开block
                            //note=([a-zA-Z0-9-]+)&&blockid=([a-zA-Z0-9-]+)&&blocktype=([a-zA-Z0-9-]+)/;

                            const link = (event.target as HTMLElement)?.closest('a')
                            const regex = /note=([a-zA-Z0-9-]+)&&blockid=([a-zA-Z0-9-]+)&&blocktype=([a-zA-Z0-9-]+)/

                            const href = (event.target as HTMLElement)?.getAttribute('href')
                            if (link && href) {
                                const match = href.match(regex)
                                // ======= 拦截自定义 noteeditor:// 协议 =======
                                if (isCardBlockDeeplink(href) && match) {
                                    event.preventDefault()

                                    const noteid = match[1]
                                    const blockid = match[2]
                                    const blocktype = match[3]
                                    document.dispatchEvent(new CustomEvent('blockLinkClick', {
                                        detail: {
                                            noteId: noteid,
                                            blockId: blockid,
                                            blockType: blocktype
                                        }
                                    }));
                                    if (callback){
                                        callback(noteid);
                                    }
                                    return true
                                }
                            }

                            // ======= 交给原始 clickHandler 处理 =======
                            return baseClickHandler.props.handleClick?.(view, pos, event) ?? false
                        },
                    },
                })
            }

            if (this.options.openOnClick) {
                plugins.push(
                    customClickHandler(this.type, this.options)
                )
            }
            return plugins
        },
        addPasteRules(){
            return [];
        },
    })
}

export const getBoldExtension = ()=>{
    return Bold.extend({
        addInputRules() {
            return [
                // 修改正则，允许中间位置触发
                markInputRule({
                    find: /(\*\*([^*]+)\*\*)$/,
                    type: this.type,
                }),
            ];
        },
    })
}

// 斜体扩展 - 支持 *text* 语法
export const getItalicExtension = ()=>{
    return Italic.extend({
        addInputRules() {
            return [];
        },
    });
}

// 删除线扩展 - 支持 ~~text~~ 语法
export const getStrikeExtension = ()=>{
    return Strike.extend({
        addInputRules() {
            return [
                markInputRule({
                    find: /(~~([^~]+)~~)$/,
                    type: this.type,
                }),
            ];
        },
    })
}

export const getOperatorAlignExtension = ()=>{
    // 运算符垂直对齐：通过 Decoration 给 + - * / 包裹 span，配合 editor.less 中的 CSS 变量控制偏移
    return Extension.create({
        name: "operatorAlign",
        addProseMirrorPlugins() {
            return [
                new Plugin({
                    key: new PluginKey("operatorAlign"),
                    props: {
                        decorations(state) {
                            const decorations: any[] = [];
                            const classMap: Record<string, string> = {
                                "+": "operator-plus",
                                "-": "operator-minus",
                                "*": "operator-mul",
                                "/": "operator-div",
                            };
                            state.doc.descendants((node, pos) => {
                                if (node.isText && node.text) {
                                    const text = node.text;
                                    for (let i = 0; i < text.length; i++) {
                                        const ch = text[i];
                                        const cls = classMap[ch];
                                        if (cls) {
                                            decorations.push(
                                                Decoration.inline(pos + i, pos + i + 1, {
                                                    class: cls,
                                                })
                                            );
                                        }
                                    }
                                }
                            });
                            return DecorationSet.create(state.doc, decorations);
                        },
                    },
                }),
            ];
        },
    })
}

export const getOperatorOnSpaceOrEnter = ()=>{
    return Extension.create({
        name: "italicOnSpaceOrEnter",
        addProseMirrorPlugins() {
            return [
                new Plugin({
                    key: new PluginKey("italicOnSpaceOrEnter"),
                    props: {
                        handleKeyDown(view, event) {
                            if (event.key !== " " && event.key !== "Enter") return false;
                            const { state } = view;
                            const { selection, schema } = state;
                            if (!selection.empty) return false;

                            const { $from } = selection;
                            const nodeStart = $from.start($from.depth);
                            const textBefore = state.doc.textBetween(nodeStart, $from.pos, "\n", "\0");
                            const italicRegex = /(?<!\*)\*([^*\s][^*]*?)\*(?!\*)$/;
                            const match = italicRegex.exec(textBefore);
                            if (!match) return false;

                            const matchStart = nodeStart + match.index;
                            const matchEnd = matchStart + match[0].length;
                            const italicMark = schema.marks.italic.create();
                            const tr = state.tr;
                            tr.delete(matchEnd - 1, matchEnd);
                            tr.delete(matchStart, matchStart + 1);
                            tr.addMark(matchStart, matchEnd - 2, italicMark);
                            tr.setStoredMarks([]);
                            const cursorPos = matchEnd - 2;
                            tr.insertText(" ", cursorPos);
                            view.dispatch(tr);
                            return true;
                        },
                    },
                }),
            ];
        },
    })
}























